import React, { Component } from 'react';
import { IoMdLogIn } from 'react-icons/io';

class CheckInPopup extends Component {

    render() {
        const { items, isOpen, colorPop } = this.props;
        //Do not show popup
        if (!isOpen || items.length === 0) return null;
        return (
            <div id="guestlist" className="popup">
                    <div className="content" style={colorPop}>
                        <div id="i-am" className="mt-3"></div>
                        {items &&
                        items.map((item, idx) => {
                            return (
                                <div className="guest-visitor mt-1" key={idx} onClick={() => this.props.selectGuestCheckIn(item.id, item.name)}>
                                    <div className="item" key={idx} id={item.id}>
                                        <IoMdLogIn /> {item.name}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

            </div>
        );
    }
}

export default CheckInPopup;